"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var splide_1 = __importDefault(require("@splidejs/splide"));
var constants_1 = require("../data/constants");
var SplideSlider = /** @class */ (function (_super) {
    __extends(SplideSlider, _super);
    function SplideSlider(selector) {
        var _this = _super.call(this) || this;
        _this.selector = selector;
        _this.sliders = document.querySelectorAll(_this.selector);
        _this.desc = document.querySelectorAll("[".concat(constants_1.DATA_MEDIA_GALLERY_DESC, "]"));
        if (_this.sliders.length < 1)
            return _this;
        // Configure slider defaults
        splide_1.default.defaults = {
            i18n: {
                prev: 'Previous slide',
                next: 'Next slide'
            }
        };
        // Configure each slider on the page
        _this.sliders.forEach(function (element) {
            //Media Gallery Slider
            if (element.dataset.slider == 'media-gallery') {
                var splideMediaGallery_1 = new splide_1.default(element, {
                    type: 'slide',
                    rewind: false,
                    speed: 1000,
                    arrows: true,
                    autoplay: false,
                    perPage: 1,
                    fixedWidth: '80vw',
                    flickMaxPages: 1,
                    lazyLoad: 'nearby',
                    trimSpace: 'move',
                    focus: 'center',
                    classes: {
                        pagination: 'splide__pagination container',
                    },
                    breakpoints: {
                        767: {
                            fixedWidth: '88vw',
                        },
                        360: {
                            fixedWidth: '80vw',
                        }
                    }
                });
                // Custom pagination
                splideMediaGallery_1.on('pagination:mounted', function (data) {
                    data.items.forEach(function (item) {
                        item.button.textContent = String(item.page + 1 + ' / ' + splideMediaGallery_1.length);
                    });
                });
                splideMediaGallery_1.on('move', function (dest) {
                    if (dest > 0 && dest + 1 < splideMediaGallery_1.length) {
                        element.classList.add('is-center');
                    }
                    else {
                        element.classList.remove('is-center');
                    }
                });
                if (_this.desc.length > 0) {
                    splideMediaGallery_1.on('move', function (dest, index) {
                        var desc = element.closest('section[data-media-gallery]').querySelectorAll("[".concat(constants_1.DATA_MEDIA_GALLERY_DESC, "]"));
                        if (dest != index) {
                            desc.item(dest).classList.add('is-active');
                            desc.item(index).classList.remove('is-active');
                        }
                    });
                }
                splideMediaGallery_1.mount();
            }
            else if (element.dataset.slider == 'form-switch') {
                //Form Switch
                var splideFormSwitch = new splide_1.default(element, {
                    type: 'slide',
                    rewind: false,
                    speed: 1000,
                    arrows: true,
                    autoplay: false,
                    fixedWidth: '120px',
                    gap: '16px',
                    flickMaxPages: 1,
                    lazyLoad: 'nearby',
                    trimSpace: 'move',
                    focus: 'center',
                    classes: {
                        pagination: 'splide__pagination container',
                    },
                });
                splideFormSwitch.mount();
            }
            else if (element.dataset.slider == 'news-teaser') {
                //News Teaser
                var splideNewsTeaser = new splide_1.default(element, {
                    type: 'slide',
                    rewind: false,
                    speed: 1000,
                    arrows: false,
                    autoplay: false,
                    perPage: 1,
                    perMove: 1,
                    gap: '32px',
                    fixedWidth: '60vw',
                    lazyLoad: 'nearby',
                    trimSpace: true,
                    breakpoints: {
                        566: {
                            fixedWidth: '83.7vw',
                            gap: '16px',
                        }
                    }
                });
                splideNewsTeaser.mount();
            }
            else {
                var splide_2 = new splide_1.default(element, {
                    type: 'slide',
                    rewind: false,
                    speed: 1000,
                    arrows: true,
                    autoplay: false,
                    perPage: 3,
                    perMove: 3,
                    fixedWidth: '25vw',
                    lazyLoad: 'nearby',
                    trimSpace: false,
                    breakpoints: {
                        1840: {
                            perPage: 3,
                            perMove: 3,
                            fixedWidth: '28.1vw',
                        },
                        992: {
                            perPage: 2,
                            perMove: 2,
                            fixedWidth: '40vw',
                        },
                        767: {
                            perPage: 1,
                            perMove: 1,
                            fixedWidth: '83.7vw',
                        }
                    }
                });
                // Custom pagination
                splide_2.on('pagination:mounted', function (data) {
                    var splideAmount;
                    splideAmount = Math.ceil(splide_2.length / 2);
                    if (window.outerWidth > 992) {
                        splideAmount = Math.ceil(splide_2.length / 3);
                    }
                    data.items.forEach(function (item) {
                        item.button.textContent = String(item.page + 1 + ' / ' + splideAmount);
                    });
                });
                splide_2.mount();
                roundTranslate(element);
            }
        });
        function roundTranslate(element) {
            var list = element.querySelector('.splide__list');
            list.addEventListener('transitionend', function () {
                var transform = getComputedStyle(list).transform;
                var matrix = new WebKitCSSMatrix(transform);
                list.style.transform = "translateX(".concat(Math.round(matrix.m41), "px)");
            });
        }
        return _this;
    }
    return SplideSlider;
}(abstractComponent_1.default));
exports.default = SplideSlider;
